import { Table } from "antd";
import { useStatsAssetProcessor } from "../../../api/hooks/stats";
import { DownloadOutlined } from "@ant-design/icons";
import { CSVLink } from "react-csv";
import dayjs from "dayjs";
import { DATE_TIME_FORMAT } from "../../../utils/date";
// import { processorInventoryData } from "./sampleData";

function InventoryWithProcessors() {
  const { data: processorInventoryData } = useStatsAssetProcessor();

  const inventoryWTProcessorsColumns = [
    {
      title: "Processor",
      // dataIndex: ["processor", "name"],
      key: "processor_name",
      render: (text) => "Processor",
    },
    {
      title: "Order Count",
      dataIndex: "totalOrderCount",
      key: "totalOrderCount",
      render: (text) => text || 0,
    },
    {
      title: "Quantity",
      dataIndex: "totalQuantityWithProcessor",
      key: "totalQuantityWithProcessor",
      render: (text) => text || 0,
    },
  ];

  function getProcessorInventoryCSVData(data = []) {
    // name will always be "Processor"
    // OrderID: orders[].referenceId
    // Shipping Date:  orders[].assetsWithProcessor[].createdAt
    // Days with customer: days between shipping date and today
    // Tag: orders[].assetsWithProcessor[].asset.tag

    const res = [["Name", "Order ID", "SHP Date", "Days With Customer", "Tag"]];
    data.forEach((ci) => {
      const { orders = [] } = ci;
      orders?.forEach((order) => {
        const { assetsWithProcessor = [] } = order;
        res.push(["Processor", order?.referenceId]);
        assetsWithProcessor?.forEach((awp) => {
          res.push([
            undefined,
            undefined,
            dayjs(awp?.createdAt).format(DATE_TIME_FORMAT),
            dayjs().diff(awp?.createdAt, "day"),
            awp?.asset?.tag,
          ]);
        });
      });
    });

    return res;
  }

  // console.table(getProcessorInventoryCSVData(processorInventoryData));

  return (
    <div className="flex flex-col gap-4 rounded-xl border-2 pb-4">
      <div className="flex items-center justify-between gap-2 rounded-t-xl bg-[#D1DFFF] px-6 py-2 text-lg">
        <div>Inventory With Processors</div>
        <div className="flex items-center gap-5">
          {Boolean(processorInventoryData?.length) && (
            <CSVLink
              filename={"processor_inventory.csv"}
              // data={
              //   processorInventoryData?.map((inv) => {
              //     const {
              //       processor = {},
              //       totalOrderCount = 0,
              //       totalQuantityWithProcessor = 0,
              //     } = inv;
              //     return {
              //       Processor: processor?.name || "Processor",
              //       "Order Count": totalOrderCount,
              //       Quantity: totalQuantityWithProcessor,
              //     };
              //   }) || []
              // }
              data={getProcessorInventoryCSVData(processorInventoryData)}
            >
              <DownloadOutlined />
            </CSVLink>
          )}
          {/* <div className="flex items-center gap-2 text-center">
            <p className="text-xs">Processing</p>
            <p className="font-bold">
              {processorInventoryData?.reduce((acc, inv) => {
                return acc + (inv?.totalQuantityWithProcessor || 0);
              }, 0) || 0}
            </p>
          </div> */}
        </div>
      </div>
      {/* <div className="flex flex-grow justify-between gap-6 divide-x px-6">
        <Table
          className="w-full"
          dataSource={processorInventoryData || []}
          columns={inventoryWTProcessorsColumns}
          rowKey={"_id"}
          pagination={false}
          size="small"
        />
      </div> */}
      <div className="flex flex-grow justify-between gap-6 divide-x px-16">
        <div className="flex-grow text-center">
          <p className="">Order Count</p>
          <p className="font-bold">
            {processorInventoryData?.reduce((acc, inv) => {
              return acc + (inv?.totalOrderCount || 0);
            }, 0) || 0}
          </p>
        </div>
        <div className="flex-grow text-center">
          <p className="">Quantity</p>
          <p className="font-bold">
            {processorInventoryData?.reduce((acc, inv) => {
              return acc + (inv?.totalQuantityWithProcessor || 0);
            }, 0) || 0}
          </p>
        </div>
      </div>
    </div>
  );
}

export default InventoryWithProcessors;
